import React, { useState, useEffect } from "react";
import Landing300MbLayout from "@/layouts/landing-300-mb";
import MetaData from "@gerenciatd/next13.core.meta-data";
import { wrapper } from "store";

const Landing600Mb = ({ seoInfo, landingProps, context }) => {
  const [landingState, setLandingPage] = useState(landingProps);

  useEffect(() => {
    const fetchData = async () => {
      const module = await Promise.all([
        await import("@gerenciatd/next13.adabyron.custo.get-by-name"),
      ]);

      const getByName = module[0].default;

      const landingProps = await getByName({
        name: "CMS-LANDING-FIBRA-600MB",
        context,
        build: false,
        kind: "creativity",
      });

      setLandingPage(landingProps);
    };

    if (process.env.NEXT_PUBLIC_ENV_NAME === "qa") {
      fetchData();
    }
  }, []);

  return (
    <>
      <MetaData seoInfo={seoInfo} />
      <Landing300MbLayout {...landingState} />
    </>
  );
};

export default Landing600Mb;

export const getStaticProps = wrapper.getStaticProps(async ({ store }) => {
  const modules = await Promise.all([
    await import("@gerenciatd/next13.adabyron.misc.get-static-content"),
    await import("@gerenciatd/next13.normalizers.components-header.sections"),
    await import(
      "@gerenciatd/next13.normalizers.components-header.breadcrumbs"
    ),
    await import("@gerenciatd/next13.reducers.header-reducer"),
    await import("@gerenciatd/next13.adabyron.custo.get-seo"),
    await import("@gerenciatd/next13.adabyron.custo.get-by-name"),
  ]);

  const getSeo = modules[4].default;
  const getByName = modules[5].default;

  const context = store.getState().main.context;

  const seoInfo = await getSeo({
    context,
    location: "web.movistar.es/promociones/fibra-600mb",
  });

  const landingProps = await getByName({
    name: "CMS-LANDING-FIBRA-600MB",
    context,
    build: true,
    kind: "creativity",
  });

  return {
    props: {
      seoInfo,
      landingProps,
      context,
    },
  };
});
